import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useTranslation, Trans } from "react-i18next";

//services
import { setLoading, setRole, setUpAuth } from "../../../reducer/auth/auth";
import { fetchUser, login, sendVerificationCode } from "../../../services/auth";
import API from "../../../api/api";
import { setUser } from "../../../reducer/userSlice";
import { userType } from "../../../utils/utils";
import { getBrowserData } from "../../../utils/helpers";

import "bootstrap/dist/css/bootstrap.min.css";
import "./newregistermedium.module.css";
import LanguageSwitcher from "../../../components/languageSwitcher";

const NewRegisterMedium = () => {
  const { t } = useTranslation("authRegister");
  const [emailError, setEmailError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [typePass, SetTypePass] = useState(true);
  const [confirmtypePass, SetTypeconfirmPass] = useState(true);
  const [oldEmail, setOldEmail] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [backupData, setBackupData] = useState();

  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    // Carousel functionality agar chahiye to yahan add karo
  }, []);

  const changePassTypeConfirm = (e) => {
    SetTypeconfirmPass(!confirmtypePass);
  };

  const changePassType = (e) => {
    SetTypePass(!typePass);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    if (!executeRecaptcha) {
      console.log("Recaptcha not yet available");
      return;
    }

    try {
      const token = await executeRecaptcha("register");
      const payload = {
        ...values,
        recaptcha_token: token,
      };
      RegisterUser(payload);
    } catch (error) {
      console.error("reCAPTCHA Error:", error);
    }
  };

  const LoginUser = async (formData) => {
    let item = {
      email: formData.email,
      password: formData.password,
    };
    let browserinfo = await getBrowserData();
    Object.assign(item, browserinfo);
    login(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          localStorage.setItem("access_token", data.data.data.access_token);
          dispatch(setUpAuth());
          callProfile(data.data.data.access_token);
          sendVerificationCodeHandler();
        }
        if (
          !data.data.status &&
          data.data.error &&
          data.data.error !== "Unauthorized"
        ) {
          setEmailError(data.data.error);
        }
        if (!data.data.status && data.data.error === "Unauthorized") {
          setEmailError("Invalid Email or Password");
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  const sendVerificationCodeHandler = () => {
    let body = {
      verification_code: "",
    };
    sendVerificationCode(body)
      .then((data) => {
        if (
          !data.data.status &&
          data.data.message === "OTP sent Successfully"
        ) {
          console.log("OTP sent Successfully");
        }
      })
      .catch((data) => {
        console.log(data);
      });
  };

  const callProfile = async (token) => {
    dispatch(setLoading(true));
    await fetchUser(token)
      .then((data) => {
        dispatch(setLoading(false));
        dispatch(setUser(data.data.data));
        renderUserType(data.data.data.usertype, data.data.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  const renderUserType = (type, users) => {
    const user = userType(type);
    dispatch(setRole(user));
    if (user === "medium") {
      if (users.status === 1 && users.medium_status === 1) {
        navigate("/dashboard");
      } else {
        navigate("/profile");
      }
    }
    if (user === "admin") {
      navigate("/dashboard");
    }
    if (user === "client") {
      navigate("/dashboard");
    }
  };

  const RegisterUser = async (formData) => {
    setBackupData(formData);
    dispatch(setLoading(true));
    let item = {
      email: formData.email,
      password: formData.password,
      password_confirmation: formData.confirmPassword,
      recaptcha_token: formData.recaptcha_token,
      is_adult: formData.check ? 1 : 0,
      usertype: 2,
    };

    if (formData.override_client) {
      Object.assign(item, { override_client: 1 });
    }

    let browserinfo = await getBrowserData();
    Object.assign(item, browserinfo);

    API.post("register", item)
      .then((data) => {
        if (data.data.status) {
          LoginUser(formData);
        }
        console.log(data.data, "data.data");
        if (!data.data.status && data.data.data.is_client == 1) {
          console.log("dewjndjknejd");
          window.loadModal2("#RegisterasMediumPopup", "show");
          setOldEmail(data.data.data.from_email);
          setNewEmail(data.data.data.to_email);
        }
        if (!data.data.status && data.data.error.email) {
          dispatch(setLoading(false));
          setEmailError("This email address already exists in our system.");
        }
        if (
          !data.data.status &&
          data.data.error &&
          data.data.error === "Your Account is Restricted/Freezed"
        ) {
          dispatch(setLoading(false));
          setEmailError(
            "You are not allowed to create new accounts. Please contact support for more help."
          );
        }
      })
      .catch((error) => {
        dispatch(setLoading(false));
        console.log(error);
      });
  };

  const redirectRoute = (item) => {
    navigate(item);
  };

  const newEmailHandler = () => {
    let newData = Object.assign(backupData, { override_client: 1 });
    console.log(newData, "newData");
    RegisterUser(newData);
    window.loadModal2("#RegisterasMediumPopup", "hide");
  };

  // Modal functions - Consistent with NewLogin.js
  const openRegistrationModal = () => {
    window.loadModal2("#registrationTypeModal", "show");
  };

  // SVG Icons
  const EmailIcon = () => (
    <svg
      className="input-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6L12 13L2 6"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const PasswordIcon = () => (
    <svg
      className="input-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="login_body">
      {/* Header Section - Same as NewLogin.js */}
      <div className="header_login">
        <div className="header_container">
          <div className="header_left">
            <div className="logo">
              <img src="/images/logo-verysoul.png" alt="Very Soul Logo" />
            </div>
          </div>
          <div className="header_right">
            <LanguageSwitcher className="header-language-switcher" />
            <span className="desktop-text">{t("shared.haveAccount")}</span>
            <span className="mobile-text"></span>
            <button className="register-btn" onClick={() => navigate("/login")}>
              {t("shared.login")}
            </button>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="container-fluid login_content">
        <div className="row justify-content-center login_row">
          {/* Left Area - Testimonial */}
          {/* Left Area */}
          <div className="card_column col-md-6 text-white bg-dark  login_left_area login_left_area-img">
              <div className="card-body text-center">
                <div className="login_inner">
                <div className="text-center login-heading">
                  <h2 className="d-none-text d-md-block real-text">{t("shared.tagline")}</h2>
                  <h2 className="d-block d-md-none">{t("shared.taglineLine1")}<br />{t("shared.taglineLine2")}</h2>
                </div>
                </div>
              </div>
            </div>

          {/* Right Area - Registration Form */}
          <div className="card_column col-md-6 p-4 mb-0 login_right_area">
            <div className="login_inner">
              <div className="card-body">
                <h1>{t("medium.title")}</h1>

                {emailError ===
                  "This email address already exists in our system." && (
                  <div className="alert alert-danger" role="alert">
                    {t("shared.errors.emailExists")}
                    <br />
                    <Link to="/login">{t("shared.clickToLogin")}</Link>
                  </div>
                )}
                {emailError ===
                  "You are not allowed to create new accounts. Please contact support for more help." && (
                  <div className="alert alert-danger" role="alert">
                    {t("shared.errors.notAllowed")}
                  </div>
                )}

                <Formik
                  initialValues={{
                    email: "",
                    password: "",
                    confirmPassword: "",
                    check: false,
                  }}
                  enableReinitialize={true}
                  validate={(values) => {
                    const errors = {};
                    if (!values.email) {
                      errors.email = t("shared.validation.required");
                    } else if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                        values.email
                      )
                    ) {
                      errors.email = t("shared.validation.invalidEmail");
                    }
                    if (!values.password) errors.password = t("shared.validation.required");
                    if (values.password && values.password.length < 6)
                      errors.password = t("shared.validation.minLength");
                    if (
                      values.password &&
                      !/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/.test(
                        values.password
                      )
                    ) {
                      errors.password =
                        t("shared.validation.passwordRule");
                    }
                    if (!values.confirmPassword)
                      errors.confirmPassword = t("shared.validation.required");
                    if (values.password !== values.confirmPassword)
                      errors.confirmPassword = t("shared.validation.passwordMismatch");
                    if (!values.check) {
                      errors.check = t("shared.validation.required");
                    }
                    return errors;
                  }}
                  onSubmit={handleSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <form className="login_form" onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} autoComplete="off">
                      {/* Email Field */}
                      <div className="mb-4 mt-4 form-group">
                        <label>{t("shared.emailLabel")}</label>
                        <div className="position-relative email-field-wrapper">
                          <div className="input-icon-wrapper">
                            <EmailIcon />
                          </div>
                          <input
                            className={`form-control ${
                              errors.email && touched.email
                                ? "error-boundry"
                                : ""
                            }`}
                            type="email"
                            name="email"
                            placeholder={t("shared.emailPlaceholder")}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            autoComplete="off"
                          />
                        </div>
                        {errors.email && touched.email && (
                          <div className="error-text">{errors.email}</div>
                        )}
                      </div>

                      {/* Password Field */}
                      <div className="mb-3 form-group">
                        <label>{t("shared.createPassword")}</label>
                        <div className="position-relative password-field-wrapper">
                          <div className="input-icon-wrapper">
                            <PasswordIcon />
                          </div>
                          <input
                            className={`form-control ${
                              errors.password && touched.password
                                ? "error-boundry"
                                : ""
                            }`}
                            type={typePass ? "password" : "text"}
                            name="password"
                            placeholder={t("shared.passwordPlaceholder")}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            autoComplete="off"
                          />
                          <div
                            className="password-toggle"
                            onClick={changePassType}
                          >
                            <img
                              src={
                                typePass
                                  ? "/images/eye.png"
                                  : "/localImages/openeye.svg"
                              }
                              alt={t("shared.togglePassword")}
                              className={`eye-icon pointer ${
                                typePass ? "" : "openeye"
                              }`}
                            />
                          </div>
                        </div>
                        {errors.password && touched.password && (
                          <div className="error-text">{errors.password}</div>
                        )}
                      </div>
                      {/* Confirm Password Field */}
                      <div className="mb-3 form-group">
                        <label>{t("shared.confirmPassword")}</label>
                        <div className="position-relative password-field-wrapper">
                          <div className="input-icon-wrapper">
                            <PasswordIcon />
                          </div>
                          <input
                            className={`form-control ${
                              errors.confirmPassword && touched.confirmPassword
                                ? "error-boundry"
                                : ""
                            }`}
                            type={confirmtypePass ? "password" : "text"}
                            name="confirmPassword"
                            placeholder={t("shared.confirmPasswordPlaceholder")}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.confirmPassword}
                            autoComplete="off"
                          />
                          <div
                            className="password-toggle"
                            onClick={changePassTypeConfirm}
                          >
                            <img
                              src={
                                confirmtypePass
                                  ? "/images/eye.png"
                                  : "/localImages/openeye.svg"
                              }
                              alt={t("shared.togglePassword")}
                              className={`eye-icon pointer ${
                                confirmtypePass ? "" : "openeye"
                              }`}
                            />
                          </div>
                        </div>
                        {errors.confirmPassword && touched.confirmPassword && (
                          <div className="error-text">
                            {errors.confirmPassword}
                          </div>
                        )}
                      </div>

                      <div className="mb-3 form-group">
                        <div className="form-check">
                          <input
                            className="form-check-input mr-5 input-checkboxx"
                            type="checkbox"
                            id="check"
                            name="check"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            checked={values.check}
                          />
                          <label className="form-check-label" htmlFor="check">
                            {t("shared.over18")}
                          </label>
                        </div>
                        {errors.check && touched.check && (
                          <div className="error-text">{errors.check}</div>
                        )}
                      </div>

                      {/* Submit Button */}
                      <div className="row">
                        <div className="col-12">
                          <button
                            className="btn btn-primary px-4 login_button"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {t("shared.signUp")}
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>

                <p className="text-body-secondary text-center mt-3">
                  <Trans
                    i18nKey="shared.haveAccountLogin"
                    ns="authRegister"
                    components={{ a: <Link to="/login" /> }}
                  />
                </p>

                <div className="text-center mt-3">
                  <a
                    href={process.env.REACT_APP_SUPPORT_URL}
                    className="contactSupport"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t("shared.contactSupport")}
                  </a>
                </div>
              </div>

              {/* Bottom Links */}
              <div className="login_bottom_area">
                <div className="login_bottom_content">
                  <div className="login_bottom_links">
                    <ul>
                      <li>
                        <Link to="/privacy-policy" target="_blank">
                          {t("common:common.privacyPolicy")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/terms-conditions" target="_blank">
                          {t("common:common.termsConditions")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <p>{t("common:common.browserNote")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Registration Type Modal - UNIQUE ID use karein */}
      {/* <div className="dont-have-acc">
        <div className="modal fade" id="registrationTypeModal" role="dialog">
          <div className="modal-dialog modal-dialog-preview">
            <div className="modal-content">
              <div className="modal-body text-align-unset">
                <div className="icon-pop text-align-center">
                  <img src="/images/Union-icon.png" alt="union-icon" />
                </div>
                <ul>
                  <li>
                    <div
                      onClick={() => redirectRoute("/registration")}
                      className="height-unset"
                      data-dismiss="modal"
                    >
                      <img src="/images/medum.png" alt="medium" />
                      <span data-dismiss="modal">
                        Register as <br />
                        Medium
                      </span>
                    </div>
                  </li>
                  <li>
                    <div
                      className="height-unset"
                      onClick={() => redirectRoute("/register-client")}
                      data-dismiss="modal"
                    >
                      <img src="/images/customer.png" alt="register" />
                      <span>
                        Register as <br />
                        Client
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Success Modal - UNIQUE ID use karein */}
      <div
        className="modal fade"
        id="successModal"
        role="dialog"
        style={{ display: "none" }}
      >
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="/images/Union-icon.png" alt="Union-icon" />
              </div>
              <h3>
                <Trans i18nKey="medium.successModal.title" ns="authRegister" />
              </h3>
              <p className="mt-4">{t("medium.successModal.body")}</p>
              <div
                className="register-medium-confirnation"
                onClick={() => redirectRoute("/thank-you")}
              >
                {t("shared.close")}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Client Conflict Modal - UNIQUE ID use karein */}
      <div className="confirm-delete-wrapper register-medium">
        <div
          className="modal fade"
          id="RegisterasMediumPopup"
          role="dialog"
          style={{ display: "none" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body m-4">
                <h3 className="">{t("medium.clientConflict.message")}</h3>
                <div className="confirm-btn-box">
                  <div
                    className="register-medium-confirnation model-close-btn"
                    onClick={() =>
                      window.loadModal2("#RegisterasMediumPopup", "hide")
                    }
                  >
                    {t("medium.clientConflict.no")}
                  </div>
                  <div
                    className="register-medium-confirnation"
                    onClick={newEmailHandler}
                  >
                    {t("medium.clientConflict.yes")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewRegisterMedium;
